import React from 'react'
import facebook from "../../../../assets/images/FACEBOOK_v.svg"
import twitter from "../../../../assets/images/TWITTER_v.svg"
import instagram from "../../../../assets/images/INSTAGRAM.svg"
import linkedin from "../../../../assets/images/LINKDIN.svg"
import cross from "../../../../assets/images/cross.svg";
import linkicon from "../../../../assets/images/linkicon.svg"

import { Link } from "react-router-dom";

const SocialMediaJsx = (props) => {
  const {
    onInputChangeHandler,onSubmitButtonClick,editSocial,changeSocialState, formError
  } = props;
  const information = props?.wholeData
  const totalInformation = props.responseData?.socialMedia

  // const [edit, setEdit] = useState(false);

  return (
    <>
      {!editSocial ? <div className="myaccountsection institutedetails">
        <div className="myaccountsectionheading">
          <h3 className="h3_style">Social Media</h3>
          <div className="mybtn">
            <button type="button" className="myadbtn" onClick={() => changeSocialState(true)}><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4597 5.8743L13.8341 4.49994L13.8341 4.49992C14.0686 4.26543 14.1858 4.14818 14.2703 4.03599C14.8063 3.32377 14.8063 2.34278 14.2703 1.63057C14.1858 1.51837 14.0686 1.40112 13.8341 1.16663L13.8341 1.16661L13.8341 1.16658C13.5996 0.932098 13.4823 0.814852 13.3701 0.730405C12.6579 0.194357 11.6769 0.194357 10.9647 0.730405C10.8525 0.814852 10.7353 0.932097 10.5008 1.16658L10.5007 1.16661L9.10713 2.56023C9.90404 3.94047 11.0608 5.08825 12.4597 5.8743ZM7.65253 4.01482L2.19046 9.4769C1.7654 9.90196 1.55287 10.1145 1.41314 10.3756C1.2734 10.6367 1.21446 10.9314 1.09657 11.5209L0.647836 13.7645C0.581314 14.0971 0.548053 14.2634 0.642661 14.358C0.737269 14.4526 0.903573 14.4194 1.23618 14.3529H1.23618L3.47983 13.9041C4.06928 13.7862 4.36401 13.7273 4.62511 13.5876C4.8862 13.4478 5.09873 13.2353 5.52379 12.8102L11.0014 7.33267C9.65352 6.48191 8.51135 5.34748 7.65253 4.01482Z" fill="white"/>
</svg></button>
          </div>
        </div>

        <div className="disgrid grid-2">
          <div className="form-fieldinner sociallink">
            <label><img src={facebook}  alt={'facebook'}/></label>
            <div className="fieldans"><Link to={{ pathname: totalInformation?.facebookUrl }} target="_blank"  rel="noreferrer" >{totalInformation?.facebookUrl}</Link></div>
           
          </div>
          <div className="form-fieldinner sociallink">
            <label><img src={twitter}  alt={'twitter'}/></label>
            <div className="fieldans"><Link to={{ pathname: totalInformation?.twitterUrl }} target="_blank"  rel="noreferrer" >{totalInformation?.twitterUrl}</Link></div>
          </div>
          <div className="form-fieldinner sociallink">
            <label><img src={instagram}  alt={'instagram'}/></label>
            <div className="fieldans"><Link to={{ pathname: totalInformation?.instagramUrl }} target="_blank"  rel="noreferrer" >{totalInformation?.instagramUrl}</Link></div>
          </div>
          <div className="form-fieldinner sociallink">
            <label><img src={linkedin}  alt={'linkedin'}/></label>
            <div className="fieldans"><Link to={{ pathname: totalInformation?.linkedinUrl }} target="_blank"  rel="noreferrer" >{totalInformation?.linkedinUrl}</Link></div>
          </div>
        </div>
      </div> : null}
      {editSocial ? <div className="myaccountsection institutedetails martop60 mb-5">
        <div className="myaccountsectionheading">
          <h3 className="h3_style">Social Media</h3>
          <div className="mybtn">
            <button type="button" className="myadbtn" onClick={() => changeSocialState(false)}>
              <img src={cross}  alt='close' />
            </button>
          </div>
        </div>

        <div className="disgrid grid-2">

          <div className="ss mb-3">
            <div className="input-container form-group social-control">
              <input type="text" className="input form-control" placeholder=" " name="facebook" value={information.facebook} onChange={onInputChangeHandler} />
              
              <img src={facebook} className="formscicon"  alt={'icon'}/>
              <span className="inputimage"><img src={linkicon}  alt="icon"/></span>
              <span className="text-danger">
                              {formError['facebook'] &&
                                (formError['facebook'] === "req"
                                  ?''
                                  : 'Link is not valid')}
                            </span>
            </div>


          </div>
          <div className="ss mb-3">
            <div className="input-container form-group social-control">
              <input type="text" className="input form-control" placeholder=" " name="twitter" value={information.twitter} onChange={onInputChangeHandler} />
              <span className="inputimage"><img src={linkicon}  alt="icon"/></span>
              <img src={twitter} className="formscicon" alt={'icon'} />
              <span className="text-danger">
                              {formError['twitter'] &&
                                (formError['twitter'] === "req"
                                  ?''
                                  : 'Link is not valid')}
                            </span>
            </div>
          </div>
          <div className="ss mb-3">
            <div className="input-container form-group social-control">
              <input type="text" className="input form-control" placeholder=" " name="insta" value={information.insta} onChange={onInputChangeHandler} />
              <span className="inputimage"><img src={linkicon}  alt="icon"/></span>
              <img src={instagram} className="formscicon"  alt={'icon'}/>
              <span className="text-danger">
                              {formError['insta'] &&
                                (formError['insta'] === "req"
                                  ?''
                                  : 'Link is not valid')}
                            </span>
            </div>

          </div>
          <div className="ss mb-3">
            <div className="input-container form-group social-control">
              <input type="text" className="input form-control" placeholder=" " name="linkedin" value={information.linkedin} onChange={onInputChangeHandler} />
              <span className="inputimage"><img src={linkicon}  alt="icon"/></span>
              <img src={linkedin} className="formscicon" alt={'icon'} />
              <span className="text-danger">
                              {formError['linkedin'] &&
                                (formError['linkedin'] === "req"
                                  ?''
                                  : 'Link is not valid')}
                            </span>
            </div>

          </div>

        </div>
        <button type="button" className="ctaonebutton widthhalf mt-4"  onClick={() => onSubmitButtonClick()}>Save</button>
      </div> : null}
    </>
  );
};

export default SocialMediaJsx;
